import React, { useState, useEffect } from "react";
import { useController, useWatch } from "react-hook-form";
import axios from "axios";
import { apiUrl } from "../../../constants";
import Dropdown2 from "../dropdown2/Dropdown2";

const Publisher = ({ control }) => {
  const [result, setResult] = useState([]);
  const [options, setOptions] = useState([]);
  const category = useWatch({ control, name: "category" });
  const isPublisher = category === "Publisher";
  const { field } = useController({
    control,
    name: "publisher",
    rules: { required: isPublisher },
  });
  const { onChange, value } = field;

  useEffect(() => {
    if (!isPublisher && value !== "") {
      onChange("");
    }
  }, [isPublisher, onChange, value]);

  useEffect(() => {
    async function getAll() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(`${apiUrl}/api/formsettings/publishers2`, {
          headers: {
            Authorization: `Bearer ${jwtToken}`,
          },
        });
        setResult(data);
      } catch (e) {
        console.error(e);
        if (e.response !== undefined) {
          console.error(e.response.data.message);
        }
      }
    }
    getAll();
  }, []);

  useEffect(() => {
    const options = [];
    result.forEach((currentPublisher) => {
      const newOption = {
        label: currentPublisher.publisher,
        value: currentPublisher.publisher,
        filename: currentPublisher.filename,
        path: currentPublisher.path,
        date: currentPublisher.date,
      };
      options.push(newOption);
    });
    setOptions(
      options.sort((a, b) =>
        a.value === b.value ? 0 : a.value < b.value ? -1 : 1
      )
    );
  }, [result]);

  return (
    <section className="publisher-wrapper">
      <div>
        <Dropdown2
          label={isPublisher ? "Publisher * " : "Publisher"}
          options={[{ label: "", value: "" }, ...options]}
          fieldRef={field}
          disabled={!isPublisher}
        />
      </div>
    </section>
  );
};

export default Publisher;
